// start:ng42.barrel
export * from './IAppConfig';
export * from './IAppState';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/store/interfaces/index.ts